import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, orderHistoriesActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, orderHistoriesActions);

export default slice.reducer;
